//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CheckboxForSelect from "./CheckboxForSelect.vue";
import vClickOutside from "v-click-outside";
const { bind, unbind } = vClickOutside.directive
export default {
  components: { CheckboxForSelect },
  props: {
    filter: {
      type: [Object, Array],
      required: true,
    },
    filterType: {
      type: String,
      required: true,
    },
    isSingle: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSearch: {
      type: Boolean,
      required: false,
      default: true
    },
    isSorting: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  data() {
    return {
      isActive: false,
      selectedEl: "",
      selectedList: [],
      isActiveSearch: false,
      el: null
    };
  },
  computed: {
    isAvailable() {
      return (
        (this.filter &&
          this.filter.sorted &&
          this.filter.sorted.length) ||
        this.searching
      );
    },

    count() {
      return this.filter?.selected?.length || 0;
    },
  },
  mounted() {
    this.selectedList = this.filter.selected;
  },
  methods: {
    toggleSelect(event) {
      console.log(this.isActive)
      console.log(event.target)
      this.isActive = !this.isActive;
    },

    clickOutside(event, el) {
      this.isActive = false;
    },

    unselectedAnother(current, all) {
      all.forEach((value) => {
        if (value.id !== current.id) {
          value.selected = false;
        }
      });
    },

    checkSelected(checkboxData) {
      if (this.isSingle) {
        this.selectedList = [];
        this.unselectedAnother(checkboxData, this.filter.sorted);
        if (checkboxData.id === "all") {
          this.selectedList = [];
        } else {
          this.selectedList.push(checkboxData);
        }
        this.selectedEl = checkboxData
        this.goToFilter();
      } else {
        if (checkboxData.id === "all") {
          this.unselectedAnother(checkboxData, this.filter.sorted);
          this.selectedList = [];
        } else {
          this.checkSelectedList(checkboxData);
        }
      }
    },

    checkSelectedList(checkboxData) {
      if (checkboxData.selected) {
        this.selectedList.push(checkboxData);
      } else {
        const filterList = this.selectedList.filter(item => item.id !== checkboxData.id);
        this.selectedList = filterList;
      }
    },

    goToFilter() {
      this.$emit(
        "goToFilter",
        this.selectedList,
        this.filterType,
        this.isSingle
      );
      this.isActive = false;
    },

    searchFilteredValue(value) {
      this.isActiveSearch = !!(value && value.length);
      this.$emit("searchFilteredValue", value, this.filterType);
    },
  },
};
